export default __webpack_public_path__ + "static/media/whatsapp-r.681fea82.svg";